import { Board } from './board';
import { Card } from './card/card';
import { CardIndexMapping } from './card/card-index-mapping';
import { SolitaireGameLogic } from './solitaire-game-logic';
import { Pile } from './card/pile';
import { PileId, PileType } from './logic-types';
import { GameLogicDepth } from './game-logic-depth';
import { Dealer } from 'game-logic';

export class GameLogicBuilder {
  public static newGame(dealer: Dealer<string>, logicVersion: number): SolitaireGameLogic {
    const cardIndexMapping = new CardIndexMapping();
    const gameLogicDepth = new GameLogicDepth();
    const board = GameLogicBuilder.createBoard(cardIndexMapping, gameLogicDepth);
    return new SolitaireGameLogic(dealer, board, cardIndexMapping, gameLogicDepth, logicVersion);
  }

  private static createBoard(
    cardIndexMapping: CardIndexMapping,
    gameLogicDepth: GameLogicDepth,
  ): Board {
    const foundations = [
      this.createPile(PileId.Foundation_01, PileType.Foundation),
      this.createPile(PileId.Foundation_02, PileType.Foundation),
      this.createPile(PileId.Foundation_03, PileType.Foundation),
      this.createPile(PileId.Foundation_04, PileType.Foundation),
    ];

    const tableaus = [
      this.createPile(PileId.Tableau_01, PileType.Tableau),
      this.createPile(PileId.Tableau_02, PileType.Tableau),
      this.createPile(PileId.Tableau_03, PileType.Tableau),
      this.createPile(PileId.Tableau_04, PileType.Tableau),
      this.createPile(PileId.Tableau_05, PileType.Tableau),
      this.createPile(PileId.Tableau_06, PileType.Tableau),
      this.createPile(PileId.Tableau_07, PileType.Tableau),
    ];

    const deck = this.createDeck(PileId.Deck, PileType.Deck, cardIndexMapping, gameLogicDepth);
    const waste = this.createPile(PileId.Waste, PileType.Waste);

    return new Board(foundations, tableaus, deck, waste);
  }

  private static createDeck(
    pileId: PileId,
    pileType: PileType,
    cardIndexMapping: CardIndexMapping,
    gameLogicDepth: GameLogicDepth,
  ): Pile {
    const pile = new Pile(pileId, pileType);

    cardIndexMapping.resetDeck();

    for (let index = 0; index < 52; ++index) {
      const card = new Card(index, cardIndexMapping, false);
      gameLogicDepth.updateCardDepth(card.index);
      pile.addCard(card);
    }

    return pile;
  }

  private static createPile(pileId: PileId, pileType: PileType) {
    return new Pile(pileId, pileType);
  }
}
